<template>
    <div>
        <!-- <b-nav-item v-on:click='showPresetDialog()' :title="$t('translations.preset_messages')" class="nav-item nav-item mb-1 btn btn-primary align-self-end">
            <span class="icon icon-md icon-preset-message-white"></span>Preset message
        </b-nav-item> -->
        
        <!-- Button trigger modal -->
        <span class="icon--message-create icon--message-create__preset" v-on:click='showPresetDialog()' v-b-tooltip :title="$t('translations.preset_messages')"></span>

        <b-modal cancel-variant centered ref="presetMessageDialog" title="Choose a preset message" size="lg">
            <p v-if='message' class="alert alert-warning mb-2">{{ $t(message) }}</p>
            <div class="search-filter mb-2">
                <label class='mr-2 sr-only' for='preset_filter'>{{ capitalise($t("translations.filter")) }}</label>
                <input class='mr-3 form-control' id='preset_filter' type='text' v-model='preset_filter' :placeholder="this.$t('translations.preset_message_search')"><span></span>
            </div>
            <p v-if='!loaded' class="text-center" >Loading preset messages ...</p>
            <p v-else-if='items && items.data && items.data.length == 0' class="text-center" >{{$t('translations.no_preset_messages_available')}}</p>
            <ul v-else class="list-group preset-messages-select-list" v-for='(item, index) in items.data' :key='index'>
                <li class="clickable list-group-item p-1 pl-3" v-on:click="presetSelect(item)" v-if="presetFilter(index)">
                    <strong>{{item.title}}</strong><br>
                    <small v-html="formatContent(excerpt(item.content, 192), true)"></small>
                </li>
            </ul>
        
            <div slot="modal-footer" class="w-100">
				<b-btn size="sm" class="float-right" variant="primary" v-on:click.prevent='$refs.presetMessageDialog.hide()'>
					{{$t('translations.close')}}
				</b-btn>
			</div>
		</b-modal>
    </div>

</template>


<script>
	export default {
		props: {
            "targetId": {},
            "message": {
                default: "",
            },
        },
		data: function(){
			return {
                items: [],
                loaded: false,
                preset_filter: "",
			};
		},
        mounted() {
        },
		computed: {

		},
		watch: {

		},
		methods: {
            initData() {
                if(!this.loaded) {
                    axios.get('/api/v1/presetmessage?p=0', {}).then((res) => {
                        this.items = res.data;
                        this.loaded = true;
                    }).catch((error) => {
                        this.handleError(error, "read");
                    });
                }
            },

            showPresetDialog() {

                this.initData();
                this.$refs.presetMessageDialog.show();
            },

            presetSelect(item) {
                this.$refs.presetMessageDialog.hide();
                // this.$parent.new_message = item.content; // Old way of inserting preset message.
                // get content of new_message textarea
                let source = document.getElementById(this.targetId).value;
                // get cursor index on textarea
                let cursorIndex = document.getElementById(this.targetId).selectionEnd;
                // Wrap new preset item around current content source and update new_message textarea
                //this.$parent.new_message = source.substring(0, cursorIndex) + item.content + source.substring(cursorIndex);
                this.$emit("select", {
                    text: source.substring(0, cursorIndex) + item.content + source.substring(cursorIndex),
                    id: item.id,
                });
            },
            
            presetFilter(index) {
                if(this.preset_filter === '' ) {
                    return this.items;
                }
                if(this.preset_filter != '') {
                    return this.items.data[index].content.toLowerCase().includes(this.preset_filter.toLowerCase()) || this.items.data[index].title.toLowerCase().includes(this.preset_filter.toLowerCase());
                }
                return false;
            },
        }
	}

</script>

<style>
.preset-messages-select-list {
    line-height: 1.1;
}
</style>
